<template>
  <v-autocomplete
                        :filter="filterObject"
                        :value="selectedChild"
                         @change="childChange"
                        :loading="childrenLookupLoadStatus==1"
                        :items="childrenLookup"
                        @update:search-input = "changeSelection"
                        class="search"
                        style="max-width: 300px;"
                        flat
                        hide-no-data
                        hide-details
                        label="Wyszukaj dziecko"
                        :dense="dense"
                        :clearable="clearable"
                        @click:clear="clearContent"
                        :disabled="disabled"
                        :readonly="selectedChild>0"
                      ></v-autocomplete>

</template>
<script>

export default {
  props: {
   excludeChildId:{
     type:Number,
     default:0
   },
   dense:{
     type:Boolean,
     default:false
   },
   clearable:{
     type:Boolean,
     default:false
   },
   disabled:{
     type:Boolean,
     default:false
   },
   selectedChild:{
     type:Number
   }
  },
  data: () => ({
    searchChild: null,
    childId:undefined
  }),
  watch:{
    selectedChild(val){
      if(!val){
        this.searchChild = null;
      }
    }
  },
  computed: {
    user(){
      return this.$store.getters.getUser;
     },
    lookups(){
      return this.$store.getters.getLookups;
    },
    childrenLookupLoadStatus(){
      return this.$store.getters.getChildrenLookupLoadStatus;
    },
    childrenLookup(){
      return this.$store.getters.getChildrenLookup;
    },
  },
  methods: {
    filterObject(item, queryText, itemText) {
      return (
        this.toAsciiUpper(itemText).indexOf(this.toAsciiUpper(queryText)) > -1
      );
    },
    toAsciiUpper(val){
      return val.toUpperCase().replace("Ą","A").replace("Ć","C").replace("Ę","E").replace("Ł","L").replace("Ó","O").replace("Ś","S").replace("Ż","Z").replace("Ź","Z").replace("Ń","N");
    },
    clearContent(){
      this.$emit('childSelected', 0)
      //this.searchChild = null;
    },
    childChange(val){
      if(val){
        this.$emit('childSelected', val)
      }
    },
    changeSelection (val) {
      if(this.selectedChild){
        val && val !== _.find(this.childrenLookup,{'value':this.selectedChild}).text && val.length>2 && this.querySelections(val)
      }else{
        val && val.length>2 && this.querySelections(val)
      }
    },
    querySelections (v) {
        this.$store.dispatch( 'searchChildrenLookup',{q:v,slug:this.excludeChildId}); 
      },
  }
};
</script>
<style scoped>
.search{
      max-width: 250px;
}
</style>